import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: React.ReactNode;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ className, label, id, ...props }, ref) => (
    <label
      htmlFor={id}
      className="flex cursor-pointer items-center gap-2 text-sm text-night-blue/80"
    >
      <input
        ref={ref}
        id={id}
        type="radio"
        className={cn(
          "h-4 w-4 border-night-blue/30 text-leaf-green-ink focus:ring-leaf-green",
          className,
        )}
        {...props}
      />
      {label && <span>{label}</span>}
    </label>
  ),
);
Radio.displayName = "Radio";
